import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface AcceptIdentificationUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function acceptIdentificationUserAction(userId: string): Promise<ApiResponse<AcceptIdentificationUserResponse>> {
  return api.put<ApiResponse<AcceptIdentificationUserResponse>>(`/users/${userId}/verify-identification`)
}
